(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["alma-card-colors"] && !Shopify.designMode) return;
  try {
    function updateAlmaPreview(card, swatch) {
    const gallery = card.querySelector('.card-gallery');
    if (!gallery || !swatch?.dataset.colorImage) return;
    let preview = gallery.querySelector('.alma-card-preview');
    if (!preview) {
      preview = document.createElement('div');
      preview.className = 'alma-card-preview';
      for (const name of ['front', 'model']) {
        const image = document.createElement('img');
        image.className = 'alma-card-preview__' + name;
        image.width = 900;
        image.height = 900;
        image.loading = 'lazy';
        preview.append(image);
      }
      gallery.append(preview);
      gallery.dataset.almaPreview = 'true';
    }
    const front = preview.querySelector('.alma-card-preview__front');
    const model = preview.querySelector('.alma-card-preview__model');
    front.src = swatch.dataset.colorImage;
    front.alt = swatch.getAttribute('aria-label');
    model.removeAttribute('src');
    model.alt = swatch.getAttribute('aria-label');
    if (swatch.dataset.modelImage) model.src = swatch.dataset.modelImage;
  }
  function initAlmaCardPreviews() {
    document.querySelectorAll('[id*="product_list_fa6P9H"] product-card').forEach(card => {
      updateAlmaPreview(card, card.querySelector('.alma-card-color[aria-current="true"]') || card.querySelector('.alma-card-color'));
    });
  }
  document.addEventListener('click', event => {
    const swatch = event.target.closest('.alma-card-color');
    if (!swatch?.closest('[id*="product_list_fa6P9H"]')) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const card = swatch.closest('product-card');
    if (!card || !swatch.dataset.colorImage) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    updateAlmaPreview(card, swatch);
    card.querySelectorAll('.alma-card-color').forEach(item => item.setAttribute('aria-current', String(item === swatch)));
    card.querySelectorAll('a:not(.alma-card-color)').forEach(link => { if (link.getAttribute('href')?.includes('/products/')) link.href = swatch.href; });
    card.setAttribute('data-featured-media-url', swatch.dataset.colorImage);
  }, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAlmaCardPreviews);
  else initAlmaCardPreviews();
  document.addEventListener('shopify:section:load', initAlmaCardPreviews);
  } catch(e) { console.error(e); }
})();

})();
